//import Table from "../Components/Table";

import { VisibilityPotential, VisibilityTradeArea, VisibilityPotentialTable } from "models/StatisticsReport";
import Table from "../Components/Table";

interface PotentialTradeAreaProps {
    data: VisibilityPotential[]
}

const PotentialTradeArea = ({data}: PotentialTradeAreaProps) => {
    
    function calculateTotals(list:VisibilityTradeArea[] | undefined) {
        
        if(!list || list.length === 0) {
            return { totaleCount: "0", totalCompanyCount: "0" }
        }
        
        let total = 0;
        let notVisible = 0;

        for(const item of list) {
            total += item.count;
            if(item.isVisible) {
                notVisible += item.count
            }
        }

        const totalCompanyCount = new Intl.NumberFormat('nb-NO').format(total - notVisible);
        const totalCount = new Intl.NumberFormat('nb-NO').format(total);

        const area = list.map((element) => {
            return {name: element.name, count: element.count, isVisible: element.isVisible }
        }).sort((a,b) => b.count - a.count);

        return { totalCount, totalCompanyCount, area, notVisible, total };
    }

    function calculateExtraBusiness(list:VisibilityPotential[], main:VisibilityPotential | undefined) {
        let total = 0;
        let notVisible = 0;

        for(const item of list) {
            if(main?.businessAreaId !== item.businessAreaId) {
                const response = calculateTotals(item.tradeArea);
                total += response.total ?? 0;
                notVisible += response.notVisible ?? 0;
            }
        }

        const totalCompanyCount = new Intl.NumberFormat('nb-NO').format(total - notVisible);
        const totalCount = new Intl.NumberFormat('nb-NO').format(total);

        return { totalCount, totalCompanyCount, notVisible, total }
    }

    const mainBusiness = data.find(main => main.mainBusiness);
    const mainBusinessCount = calculateTotals(mainBusiness?.tradeArea);
    const extraBusiness = calculateExtraBusiness(data, mainBusiness);

    const handleIsVisible = (data:VisibilityPotential) => {
        
        if(data.isVisible) {
            return <i className="bi bi-eye text-secondary text-success me-1"></i>
        }
        return <i className="bi bi-eye-slash cc-color-orange me-1"></i>;
    }

    const totalNotvisible =  new Intl.NumberFormat('nb-NO').format(((mainBusinessCount.total ?? 0) - (mainBusinessCount.notVisible ?? 0)) + (extraBusiness.total - extraBusiness.notVisible));

    return (
        <div className="card mb-4">
            <div className="card-header">
                <h2 className="fw-bold">OBS! Din bedrift har større potensiale!</h2>
            </div>
            <div className="card-body">
                <p className="mb-4 d-flex gap-2">
                    <i className="bi bi-eye-slash cc-color-orange"></i>
                    <span>Din bedrift er ikke synlig ved {totalNotvisible} søk i nærliggende områder og tilleggsbransjer!</span>
                </p>
                <h3 className="fs-6 mb-2 mt-2 fw-semibold">Hovedbransje: {mainBusiness?.businessArea}. Ikke synlig i {mainBusinessCount.totalCompanyCount} av {mainBusinessCount.totalCount} søk</h3>
                <Table useSlice={false}  data={mainBusinessCount.area as VisibilityPotentialTable[]} columnName={["Område", "Søk"]} />
                <h3 className="fs-6 mb-3 fw-semibold">Tilleggsbransjer. Ikke synlig i {extraBusiness.totalCompanyCount} av {extraBusiness.totalCount} søk</h3>
                <div className="cc-details-summary">
                    {data.map((element) => {
                        if(!element.mainBusiness) {
                            var business = calculateTotals(element.tradeArea);
                            return (
                                <details key={element.businessAreaId} className="mb-1">
                                    <summary>
                                        {handleIsVisible(element)} {element.businessArea}
                                    </summary>
                                    <div className="ps-3">
                                        <Table useSlice={false} data={business.area as VisibilityPotentialTable[]} columnName={["Område", "Søk"]} />
                                    </div>
                                </details>
                            );
                        }
                        return null;
                    })}
                    {/* <details className="mb-1">
                        <summary>
                            <i className="bi bi-eye-slash cc-color-orange"></i> {} Tilleggsbransje ikke synlig
                        </summary>
                        <div className="ps-3">
                            <Table data={} columnName={["Område", "Søk"]} />
                            Her kommer tabell
                        </div>
                    </details>
                    <details className="mb-1">
                        <summary>
                            <i className="bi bi-eye text-secondary text-success"></i> {} Tilleggsbransje synlig
                        </summary>
                        <div className="ps-3">
                            <Table data={} columnName={["Område", "Søk"]} />
                            Her kommer tabell
                        </div>
                    </details> */}
                    <p className="mt-4 mb-0"><a href="https://outlook.office365.com/book/Ringmegforsepmuligheter@dm1881.onmicrosoft.com/" className="fw-medium">Kontakt oss for å bli synlig ved søk i flere bransjer og større område</a></p>
                </div>
            </div>
        </div>
    );
}

export default PotentialTradeArea;